module.exports = __webpack_public_path__ + "img/CheckCircleSolid.896cd00b.png";